var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-container"},[_c('StageBadge'),_c('img',{attrs:{"src":"/img/logo-prostatype@2x.png","width":"228","height":"auto","alt":"Prostatype"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }